import { sendEvent } from "@app/utils/tracking/Tracker";

export const openChecklist = sendEvent<{ numComplete: number }>(
  "open_checklist"
);
export const dismissChecklist = sendEvent<{ complete: boolean }>(
  "dismiss_checklist"
);
